export const getLinks = (input: string | undefined) => {
  if (!input) {
    return []
  }
  // get links in string. Linh referred "https://stackoverflow.com/questions/1500260/detect-urls-in-text-with-javascript"
  const urlRegex = /(https?:\/\/[^\s]+)/g
  return input.match(urlRegex)
}

export const getYtbThumb = (
  input: string,
  ytbQuantity?: string
): string | null => {
  if (!input || !input.length) {
    return ''
  }
  // regex get id of youtube. Link referred "https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url"
  const urlYtbRegex =
    /(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\/?\?v=|\/embed\/|\/)([^\s&?/#]+)/
  const match = input.match(urlYtbRegex)
  ytbQuantity = ytbQuantity ?? 'mqdefault'
  if (match && match.length && match[1]) {
    const id = match[1]
    return `https://img.youtube.com/vi/${id}/${ytbQuantity}.jpg`
  } else {
    return ''
  }
}

export const getYtbEmbed = (input: string): string | null => {
  if (!input || !input.length) {
    return ''
  }
  // regex get id of youtube. Link referred "https://stackoverflow.com/questions/3452546/how-do-i-get-the-youtube-video-id-from-a-url"
  const urlYtbRegex =
    /(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\/?\?v=|\/embed\/|\/)([^\s&?/#]+)/
  const match = input.match(urlYtbRegex)
  if (match && match.length && match[1]) {
    const id = match[1]
    return `https://www.youtube.com/embed/${id}`
  } else {
    return ''
  }
}

export interface YoutubeUtils {
  getLinks: typeof getLinks
  getYtbThumb: typeof getYtbThumb
  getYtbEmbed: typeof getYtbEmbed
}
